import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Briefcase } from 'lucide-react'
import { UseFormReturn } from 'react-hook-form'

export const CompanyNameInput = ({form,disabled}:{form:UseFormReturn<any>,disabled?:boolean}) => {
    return (
        <FormField
            control={form.control}
            name="companyName"
            render={() => (
                <FormItem className="space-y-2">
                    <Label htmlFor="company" className="text-base font-semibold flex items-center gap-2">
                        <Briefcase className="w-5 h-5" />
                        Company
                    </Label>
                    <FormControl>
                        <Input
                            //id="company"
                            placeholder="Enter company name"
                            {...form.register("companyName")}
                            //required
                            className={`w-full transition-all duration-200 focus:ring-2 focus:ring-[#22b4b1] ${
                                form.formState.errors["companyName"] ? "border-red-500" : "border"
                            }`}
                            disabled={disabled}
                            />
                    </FormControl>
                    {form.formState.errors["companyName"] && (
                        <FormMessage className="text-red-500"/>
                    )}
                </FormItem>
            )}
        />
  )
}
